import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useAddBrandsMutation } from "../../Services/BrandsAPI";
import { useNavigate } from "react-router-dom";

function AddCategory() {
    const navigate = useNavigate();
    const [categoryName, setCategoryName] = useState("");
    const [categoryImage, setCategoryImage] = useState(null);
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);

    const [addCategory, { isLoading }] = useAddBrandsMutation();

    const validateForm = () => {
        let newErrors = {};
        if (!categoryName.trim()) newErrors.categoryName = "Name is required";
        if (!categoryImage) newErrors.categoryImage = "Image is required";

        if (!description.trim()) newErrors.description = "Description is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✅ Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return; // Stop if validation fails

        const formData = new FormData();
        formData.append("name", categoryName);
        formData.append("image", categoryImage);
        formData.append("description", description);

        try {
            await addCategory(formData).unwrap();
            alert("Brand added successfully!");
            // Reset form fields
            setCategoryName("");
            setCategoryImage(null);
            setDescription("");
            setErrors({});
            setApiError(null);
            navigate("/list-brands")
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>Add Brands</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/list-brands"><span>Brands</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Add</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        {/* Category Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Brand Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter Brand Name"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                                {errors.categoryName && <p className="text-danger">{errors.categoryName}</p>}
                            </div>
                        </div>

                        {/* Category Image */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_image" className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="category_image"
                                    onChange={(e) => setCategoryImage(e.target.files[0])}
                                />
                                {errors.categoryImage && <p className="text-danger">{errors.categoryImage}</p>}
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start">
                                <label htmlFor="description" className="form-label w-100">Description</label><br />
                                <textarea
                                    rows={4}
                                    name="description"
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                {errors.description && <p className="text-danger">{errors.description}</p>}
                            </div>
                        </div>
                    </div>



                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
